module.exports = __webpack_public_path__ + "static/media/note_pad.a82e2283.png";